import { render, staticRenderFns } from "./SchoolTeachersTBD.vue?vue&type=template&id=2ce7c388&scoped=true&"
import script from "./SchoolTeachersTBD.vue?vue&type=script&lang=js&"
export * from "./SchoolTeachersTBD.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeachersTBD.vue?vue&type=style&index=0&id=2ce7c388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7c388",
  null
  
)

export default component.exports